// @ts-nocheck
import { getValveSelectors } from "@store/Framework/Services/ValveConfiguratorService";
import { SelectorsResponseModel } from "@store/Framework/Types/ValveConfiguratorApiModels";
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

export interface LoadSelectorsResult {
    apiResult?: SelectorsResponseModel;
}

type HandlerType = Handler<{}, LoadSelectorsResult>;

export const DispatchBeginLoadSelectors: HandlerType = props => {
    props.dispatch({ type: "Data/ValveConfigurator/BeginLoadSelectors" });
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getValveSelectors();
    } catch (error) {
        const message = error instanceof Error ? error.message : "Could not load selectors.";
        props.dispatch({ type: "Data/ValveConfigurator/FailLoadSelectors", message });
        return false;
    }
};

export const DispatchCompleteLoadSelectors: HandlerType = ({ dispatch, apiResult }) => {
    if (!apiResult) {
        return;
    }

    dispatch({ type: "Data/ValveConfigurator/CompleteLoadSelectors", result: apiResult });
};

export const chain = [DispatchBeginLoadSelectors, RequestDataFromApi, DispatchCompleteLoadSelectors];

const loadValveSelectors = createHandlerChainRunner(chain, "LoadValveSelectors");
export default loadValveSelectors;
